module.exports = __webpack_public_path__ + "static/img/Linke.12ff663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LogosExperten/Parteien/Linke.png
// module id = 31
// module chunks = 0